import Picker from '@emoji-mart/react'
import GeneralPromptStyles from 'common/Prose/Prompts/Prompt/Prompt.module.scss'
import { type EditorView } from 'prosemirror-view'
import { createRoot } from 'react-dom/client'
import { BaseEmoji } from 'types'
import Styles from './Prompt.module.scss'

interface Props {
  // this is empty when user clicks "Cancel" within the prompt
  onSubmit: (payload?: BaseEmoji) => void
}

const PromptContent = ({ onSubmit }: Props) => {
  return (
    <div className={Styles.mediaUploadContainer}>
      <Picker autoFocus onEmojiSelect={(emoji: BaseEmoji) => onSubmit(emoji)} theme="light" previewPosition="none" />
    </div>
  )
}

export const openEmojiPrompt = async (view: EditorView, position: { left: number; top: number }, fixed?: boolean) => {
  const minimumHeight = 500
  if (window.innerHeight - position.top < minimumHeight) position.top = window.innerHeight - minimumHeight

  const wrapper = document.createElement('div')
  wrapper.className = GeneralPromptStyles.promptWrapper
  wrapper.style.top = position.top + 'px'
  wrapper.style.left = position.left + 'px'
  if (fixed) wrapper.style.position = 'fixed'
  const root = createRoot(wrapper)
  document.body.appendChild(wrapper)

  const mouseOutside = (e: MouseEvent) => {
    if (!(e.target instanceof Node) || !wrapper.contains(e.target)) close()
  }
  setTimeout(() => window.addEventListener('mousedown', mouseOutside), 50)

  let resolveRef: Function

  const closePromise = new Promise<BaseEmoji>((resolve) => {
    resolveRef = resolve
  })

  const close = (emoji?: BaseEmoji) => {
    window.removeEventListener('mousedown', mouseOutside)
    root.unmount()
    wrapper.remove()
    view.focus()
    if (emoji) {
      resolveRef(emoji)
    }
  }

  root.render(<PromptContent onSubmit={(payload) => close(payload)} />)

  return closePromise
}
